// ContractBasis/LaneGroup API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type LaneGroupRequests = {
    update: RequestConfigFunction<{ id: number }>,
    editableData: RequestConfigFunction<{ id: number }>,
    get: RequestConfigFunction<{ id: number }>,
    duplicate: RequestConfigFunction<{ id: number }>,
    archive: RequestConfigFunction<{ id: number }>,
    restore: RequestConfigFunction<{ id: number }>,
    modifications: RequestConfigFunction<{ id: number }>,
    laneFeesModifications: RequestConfigFunction<{ id: number }>,
    laneModifications: RequestConfigFunction<{ id: number }>,
    handoverData: RequestConfigFunction<{ data: any }>,
    checkAwardedLanes: RequestConfigFunction<{ id: number }>,
    // Lane Fees methods
    createLaneFee: RequestConfigFunction<{ laneGroupId: number }>,
    getLaneFeesByLaneGroup: RequestConfigFunction<{
        laneGroupId: number,
        params?: any,
    }>,
    filterLaneFees: RequestConfigFunction<{ laneGroupId: number }>,
    getLaneByLaneGroup: RequestConfigFunction<{ laneGroupId: number, params?: any }>,
    createLane: RequestConfigFunction<{ laneGroupId: number }>,
}

const laneGroupRequests: LaneGroupRequests = {
    update: ({
        id,
    }) => {
        return {
            url: `lanegroup/${id}`,
            method: 'PATCH',
        }
    },
    editableData: ({
        id,
    }) => {
        return {
            url: `lanegroup/${id}/editable-data`,
            method: 'PATCH',
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `lanegroup/${id}`,
            method: 'GET',
        }
    },
    duplicate: ({
        id,
    }) => {
        return {
            url: `lanegroup/${id}/duplication`,
            method: 'PATCH',
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `lanegroup/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `lanegroup/${id}/restore`,
            method: 'PATCH',
        }
    },
    modifications: ({
        id,
    }) => {
        return {
            url: `lanegroup/${id}/modifications`,
            method: 'GET',
        }
    },
    laneFeesModifications: ({
        id,
    }) => {
        return {
            url: `lanegroup/${id}/lanefees/modifications`,
            method: 'GET',
        }
    },
    laneModifications: ({
        id,
    }) => {
        return {
            url: `lanegroup/${id}/lane/modifications`,
            method: 'GET',
        }
    },
    handoverData: ({
        data,
    }) => {
        return {
            url: `lanegroup/${data.id}/handover-data`,
            method: 'PATCH',
            data,
        }
    },
    checkAwardedLanes: ({
        id,
    }) => {
        return {
            url: `lanegroup/${id}/awarded-implemented-lanes-data`,
            method: 'GET',
        }
    },
    // Lane Fees methods
    createLaneFee: ({
        laneGroupId,
    }) => {
        return {
            url: `lanegroup/${laneGroupId}/lanefees`,
            method: 'POST',
            domainName: 'LaneFeesCreateDto',
        }
    },
    getLaneFeesByLaneGroup: ({
        laneGroupId,
        params,
    }) => {
        return {
            url: `lanegroup/${laneGroupId}/lanefees/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    filterLaneFees: ({
        laneGroupId,
    }) => {
        return {
            url: `lanegroup/${laneGroupId}/lanefees/filter-request/all`,
            method: 'POST',
        }
    },
    getLaneByLaneGroup: ({
        laneGroupId,
        params,
    }) => {
        return {
            url: `lanegroup/${laneGroupId}/lane/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    createLane: ({
        laneGroupId,
    }) => {
        return {
            url: `lanegroup/${laneGroupId}/lane`,
            method: 'POST',
        }
    },
}

export default laneGroupRequests
